<script lang="ts">
  import { onMount } from "svelte";

  import Cart from "../../shared_components/Cart.svelte";
  import Details from "./Details.svelte";
  import DetailsPlaceholder from "./DetailsPlaceholder.svelte";
  import LanguageSelector from "../../shared_components/LanguageSelector.svelte";

  import lang from "../../lang/language";

  import serviceStore from "../../store/service";
  import { getListUrl } from "../../helpers/url";
  import { getUrlParam } from "../../helpers/url";
  import Divider from "../../shared_components/Divider.svelte";
  import StickyWishlist from "../../shared_components/wishlist/StickyWishlist.svelte";

  class ServiceType {}

  let selectedService: ServiceType;
  let services = serviceStore.data;

  $: {
    selectedService = $services[0];
  }

  onMount(() => {
    serviceStore.search({ Id: getUrlParam("id") });
  });
</script>

<Cart />
<div class="box">
  <div class="breadcrumb">
    <div class="row space-between">
      <div>
        <a href="/">{lang.home}</a>
        <span class="separator">|</span>
        <a href={getListUrl()}>{lang.list}</a>
        <span class="separator">|</span>
        <span>{lang.details}</span>
      </div>
      <div>
        <LanguageSelector />
      </div>
    </div>
  </div>
  <Divider>
    <div slot="col-1">
      {#if selectedService}
        <Details {selectedService} />
      {:else}
        <DetailsPlaceholder />
      {/if}
    </div>

    <StickyWishlist slot="sticky" />
  </Divider>
</div>

<style>
  .box {
    width: 97%;
    max-width: 1280px;
  }
</style>
